export default "__VITE_ASSET__0ced19a5__"